module.exports = __webpack_public_path__ + "assets/triangle-a2e1cc.svg";